import { Button, styled } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import type { ChallengeStatus } from '../utils/getChallengeStatus';

interface JoinButtonProps {
    joined: boolean;
    status: ChallengeStatus;
    joiningLoading: boolean;
    onJoinClick: () => void;
    theme?: 'dark' | 'light';
}

export const JoinButton = ({
    joined,
    status,
    joiningLoading,
    onJoinClick,
    theme = 'light',
}: JoinButtonProps) => {
    const disabled = joined || status === 'ended';
    const isOutlined = disabled;

    return (
        <JoinButtonComponent
            variant={isOutlined ? 'outlined' : 'contained'}
            disabled={disabled}
            loading={joiningLoading}
            onClick={onJoinClick}
            fullWidth
            inverted={theme === 'dark' && isOutlined}
            sx={{ visibility: !joined && status === 'ended' ? 'hidden' : 'visible' }}
        >
            {joined
                ? trans('btn-challenge-joined', {}, 'student-challenges')
                : trans('btn-join-challenge', {}, 'student-challenges')}
        </JoinButtonComponent>
    );
};

const JoinButtonComponent = styled(Button)(({ theme, disabled }) => ({
    [theme.breakpoints.up('sm')]: {
        maxWidth: 240,
    },
    ...(disabled && {
        opacity: 0.8,
    }),
}));
